import { Component, Input, OnInit } from '@angular/core';
import { AuthService } from '../../services/auth.service';
import { environment } from '../../../../environments/environment';

@Component({
  selector: 'app-loader',
  templateUrl: './app-loader.component.html',
  styleUrl: './app-loader.component.scss',
})
export class AppLoaderComponent implements OnInit {
  readonly appName = environment.appName;
  readonly isDevelopment =
    environment.appEnv === 'development' && environment.enableDevBadge;

  constructor(public authService: AuthService) {}

  ngOnInit(): void {}
}
